import { BbMediaclipsPublisherComponent } from './../components/shared/bb-mediaclips-publisher/bb-mediaclips-publisher.component';

import { BbFiltersComponent } from '../components/shared/bb-filters/bb-filters.component';
import { AdServicesService } from '../services/ad-services.service';
import { WorklistService } from '../services/worklist.service';
import { BbWorklistComponent } from '../components/shared/bb-worklist/bb-worklist.component';
import { BbDragSelectorComponent } from '../components/shared/bb-drag-selector/bb-drag-selector.component';
import { BbResizableScrollbarComponent } from '../components/shared/bb-resizable-scrollbar/bb-resizable-scrollbar.component';
import { BbResizeHandlesComponent } from '../components/shared/bb-resize-handles/bb-resize-handles.component';
import { ProjectKpiService } from './../services/project-kpi.service';
import { FlowchartService } from './../services/flowchart.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from './pipes.module';
import { InputsModule } from './inputs.module';
import { DirectivesModule } from './directives.module';
import { DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { MaterialModule } from './material.module';

import { BbTableModule } from './bb-table.module';

import { BbMessageComponent } from './../components/shared/bb-message/bb-message.component';
import { BbModalComponent } from './../components/shared/bb-modal/bb-modal.component';
import { BbPageHeaderComponent } from '../components/shared/bb-page-header/bb-page-header.component';
import { BbPasswordInputComponent } from './../components/shared/bb-password-input/bb-password-input.component';
import { BbFacetFilterComponent } from './../components/shared/bb-facet-filter/bb-facet-filter.component';
import { BbFiltersControlsComponent } from '../components/shared/bb-filters-controls/bb-filters-controls.component';
import { BbFilterSetComponent } from '../components/shared/bb-filter-set/bb-filter-set.component';
import { BbHorizontalFiltersetComponent } from '../components/shared/bb-horizontal-filter/bb-horizontal-filterset.component';
import { BbHorizontalFilterComponent } from '../components/shared/bb-horizontal-filter/bb-horizontal-filter.component';
import { BbVerticalFilterComponent } from '../components/shared/bb-vertical-filter/bb-vertical-filter.component';
import { BbFacetListComponent } from '../components/shared/bb-facet-list/bb-facet-list.component';
import { ThumbnailSelectorComponent } from '../components/shared/thumbnail-selector/thumbnail-selector.component';
import { BbNotificationCenterComponent } from '../components/shared/bb-notification-center/bb-notification-center.component';
import { BbObjectEditorComponent } from '../components/shared/bb-object-editor/bb-object-editor.component';
import { BbHubspotComponent } from '../components/shared/bb-hubspot/bb-hubspot.component';
import { BbUserMenuComponent } from '../components/user/bb-user-menu.component';
import { BbTextComponent } from '../components/shared/bb-text/bb-text.component';
import { BbTileComponent } from './../components/shared/bb-tile/bb-tile.component';
import { BbTimeComponent } from '../components/shared/bb-time/bb-time.component';
import { BbTimecodeEditorComponent } from '../components/shared/bb-timecode-editor/bb-timecode-editor.component';
import { BbTrimComponent } from '../components/shared/bb-trim/bb-trim.component';
import { BbFrameSelectComponent } from '../components/shared/bb-frame-select/bb-frame-select.component';
import { BbScreenshotComponent } from '../components/shared/bb-screenshot/bb-screenshot.component';

import { BbCanvasComponent } from '../components/shared/bb-canvas/bb-canvas.component';
import { BbCanvasElementComponent } from '../components/shared/bb-canvas-element/bb-canvas-element.component';
import { BbChartComponent } from '../components/shared/bb-chart/bb-chart.component';
import { BbChipComponent } from './../components/shared/bb-chip/bb-chip.component';
import { BbLabelCodeListComponent } from './../components/shared/bb-label-code-list/bb-label-code-list.component';
import { BbListComponent } from './../components/shared/bb-list/bb-list.component';
import { BbLoadingComponent } from '../components/shared/bb-loading/bb-loading.component';
import { BbFlagComponent } from '../components/shared/bb-flag/bb-flag.component';
import { BbPlayerComponent } from '../components/shared/bb-player/bb-player.component';
import { BasicPlayerComponent } from '../components/shared/basic-player/basic-player.component';
import { BbActionsBarComponent } from '../components/shared/bb-actions-bar/bb-actions-bar.component';
import { BbActiveFiltersComponent } from './../components/shared/bb-active-filters/bb-active-filters.component';
import { BbButtonComponent } from '../components/shared/bb-button/bb-button.component';
import { BbButtonToggleComponent } from '../components/shared/bb-button-toggle/bb-button-toggle.component';
import { BbUploadComponent } from '../components/shared/bb-upload/bb-upload.component';
import { BbImportComponent } from '../components/shared/bb-import/bb-import.component';
import { BbUploadStatusBoxComponent } from './../components/shared/bb-upload-status-box/bb-upload-status-box.component';
import { BbScrollablePaneComponent } from '../components/shared/bb-scrollable-pane/bb-scrollable-pane.component';
import { BbDataSourcePickerComponent } from '../components/shared/bb-data-source-picker/bb-data-source-picker.component';
import { BbDropdownButtonComponent } from '../components/shared/bb-dropdown-button/bb-dropdown-button.component';
import { BbEditAppComponent } from '../components/shared/bb-edit-app/bb-edit-app.component';
import { BbEditCycleComponent } from './../components/shared/bb-edit-cycle/bb-edit-cycle.component';
import { BbAboutComponent } from '../components/shared/bb-about/bb-about.component';
import { BbTechnicalInfoComponent } from '../components/shared/bb-technical-info/bb-technical-info.component';
import { BbAdstatsBlocksComponent } from '../components/shared/bb-adstats-blocks/bb-adstats-blocks.component';
import { BbEmbargoComponent } from '../components/shared/bb-embargo/bb-embargo.component';
import { BbVastCreativeComponent } from '../components/shared/bb-vast-creative-preview/bb-vast-creative-preview.component';
import { BbEmbedBarComponent } from './../components/shared/bb-embed-bar/bb-embed-bar.component';
import { BbEmptyComponent } from './../components/shared/bb-empty/bb-empty.component';
import { BbEntityDetailsComponent } from './../components/shared/bb-entity-details/bb-entity-details.component';
import { BbContextMenuComponent } from './../components/shared/bb-context-menu/bb-context-menu.component';
import { BbCronComponent } from './../components/shared/bb-cron/bb-cron.component';
import { BbDataGridComponent } from './../components/shared/bb-data-grid/bb-data-grid.component';
import { BbStateHistoryComponent } from './../components/shared/bb-state-history/bb-state-history.component';
import { BbMultiselectComponent } from './../components/shared/bb-multiselect/bb-multiselect.component';
import { BbPrebidFieldsComponent } from './../components/shared/bb-prebid-fields/bb-prebid-fields.component';
import { BbAspectRatioPickerComponent } from './../components/shared/bb-aspect-ratio-picker/bb-aspect-ratio-picker.component';
import { BbAuctionSettingsComponent } from './../components/shared/bb-auction-settings/bb-auction-settings.component';
import { BbQRCodeComponent } from './../components/shared/bb-qrcode/bb-qrcode.component';
import { BbPillboxComponent } from './../components/shared/bb-pillbox/bb-pillbox.component';
import { BbPresetsFilterListComponent } from '../components/shared/bb-presets-filter-list/bb-presets-filter-list.component';
import { BbPreviewPageComponent } from './../components/shared/bb-preview-page/bb-preview-page.component';
import { BbTranscodingComponent } from '../components/shared/bb-transcoding/bb-transcoding.component';
import { BbVersionsComponent } from '../components/shared/bb-versions/bb-versions.component';

import { BbWeekTimeGridComponent } from './../components/shared/bb-week-time-grid/bb-week-time-grid.component';
import { BbWysiwygComponent } from '../components/shared/bb-wysiwyg/bb-wysiwyg.component';

import { FlowchartStatsStepComponent } from './../components/shared/flowchart-editor/flowchart-stats-step.component';
import { FlowchartStepComponent } from './../components/shared/flowchart-editor/flowchart-step.component';
import { FlowchartEditorComponent } from './../components/shared/flowchart-editor/flowchart-editor.component';
import { FlowchartColumnsComponent } from '../components/shared/flowchart-editor/flowchart-columns.component';

import { NavigateAwayGuard } from '../components/shared/abstract-details.component';

import { SapiService } from '../services/sapi.service';
import { LineupService } from '../services/lineup.service';
import { LiveApiService } from '../services/live-api.service';
import { PublicationService } from '../services/publication.service';
import { LocationService } from '../services/location.service';
import { MediaclipService } from './../services/mediaclip.service';
import { FilterSetService } from '../services/filter-set.service';
import { AuthenticationService } from '../services/authentication.service';
import { RealtimeService } from '../services/realtime.service';
import { PrebidService } from '../services/prebid.service';
import { ProjectService } from '../services/project.service';
import { AssetService } from '../services/asset.service';
import { AnalyticsService } from './../services/analytics.service';
import { BbMacrosService } from './../services/bb-macros.service';
import { CustomFieldsService } from '../services/custom-fields.service';
import { MenuService } from '../services/menu.service';
import { ToasterService } from './../services/toaster.service';

import { DatafeedService } from '../services/datafeed.service';
import { EntityStoreService } from '../services/entity-store.service';
import { EntityService } from '../services/entity.service';
import { FeatureDetectionService } from '../services/feature-detection.service';
import { ReleaseService } from '../services/release.service';
import { UploadService } from './../services/upload.service';
import { TimeService } from './../services/time.service';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { RouterModule } from '@angular/router';

import { BbAnalyticsMenuComponent } from '../components/analytics/bb-analytics-menu.component';
import { BbLibraryMenuComponent } from '../components/library/bb-library-menu.component';
import { BbAdservicesMenuComponent } from './../components/adservices/bb-adservices-menu.component';
import { BbPublicationMenuComponent } from './../components/publication/bb-publication-menu.component';

import { BbTempBackMobileComponent } from './../components/shared/bb-temp-back-mobile/bb-temp-back-mobile.component';
import { BbSelect6Component } from '../components/shared/bb-select-6/bb-select-6.component';
import { BbEventHandlersComponent } from '../components/shared/bb-event-handlers/bb-event-handlers.component';
import { BbEntitySelectorComponent } from '../components/shared/bb-entity-selector/bb-entity-selector.component';
import { BbFieldRendererComponent } from '../components/shared/bb-field-renderer/bb-field-renderer.component';

import { BbColorPanelComponent } from '../components/shared/bb-color-panel/bb-color-panel.component';
import { BbCloningInfoComponent } from '../components/shared/bb-cloning-info/bb-cloning-info.component';
import { BbCodeEditorComponent } from './../components/shared/bb-code-editor/bb-code-editor.component';
import { BbCollapsibleComponent } from './../components/shared/bb-collapsible/bb-collapsible.component';
import { BbMenuPanelComponent } from '../components/shared/bb-menu-panel/bb-menu-panel.component';
import { BbColorPickerBoxComponent } from '../components/shared/bb-color-picker-box/bb-color-picker-box.component';
import { IeFormFieldComponent } from '../components/shared/interactivity-editor/components/ie-form-field/ie-form-field.component';

import { BbDimensionComponent } from '../components/shared/bb-dimension/bb-dimension.component';
import { UserPreferencesComponent } from '../components/user/user-preferences.component';
import { BbMediaclipSelectorComponent } from '../components/shared/bb-mediaclip-selector/bb-mediaclip-selector.component';
import { BbTableThumbnailComponent } from '../components/shared/bb-table-thumbnail/bb-table-thumbnail.component';

import { BbLogoSelectorComponent } from '../components/shared/bb-logo-selector/bb-logo-selector.component';
import { BbMacroSuggestionsComponent } from '../components/shared/bb-macro-suggestions/bb-macro-suggestions.component';
import { BbSolrQueryDocumentationComponent } from '../components/shared/bb-solr-query/bb-solr-query-documentation.component';

import { BbSelectService } from '../services/bb-select.service';
import { BbDatePresetsComponent } from '../components/shared/bb-date-presets/bb-date-presets.component';
import { BbChannelComponent } from '../components/shared/bb-channel/bb-channel.component';
import { BbChapterEditorComponent } from '../components/shared/bb-chapter-editor/bb-chapter-editor.component';
import { BbSubtitleLineEditorComponent } from '../components/shared/bb-subtitle-line-editor/bb-subtitle-line-editor.component';
import { BbPlayerAspectRatioComponent } from '../components/shared/bb-player-aspect-ratio/bb-player-aspect-ratio';
import { BbToastrComponent } from './../components/shared/bb-toastr/bb-toastr.component';

import { MatIconModule } from '@angular/material/icon';
import { BbReactComponent } from 'app/components/shared/bb-react/bb-react.component';
import { BbHamburgerOverlayComponent } from 'app/components/shared/bb-hamburger-overlay/bb-hamburger-overlay.component';
import { BbReactQuickEditComponent } from 'app/components/shared/bb-react-quickedit/bb-react-quickedit.component';
import { BbCreatePresetComponent } from 'app/components/shared/bb-create-preset/bb-create-preset.component';
import { LoginUserComponent } from 'app/components/login/login-user.component';
import { LoginUserSsoComponent } from 'app/components/login/login-user-sso.component';
import { LoginForgotPasswordComponent } from 'app/components/login/login-forgot-password.component';
import { BbLineTextComponent } from 'app/components/shared/bb-line-text/bb-line-text.component';
import { LoginChoosePublicationComponent } from 'app/components/login/login-choose-publication.component';
import { LoginResetPasswordComponent } from 'app/components/login/login-reset-password.component';

@NgModule({
	imports: [
		CommonModule,
		PipesModule,
		TranslateModule,
		RouterModule,
		InputsModule,
		DirectivesModule,
		MaterialModule,
		ReactiveFormsModule,
		BbTableModule,
		ColorPickerModule,
		MatIconModule,
		CKEditorModule
	],
	declarations: [
		BbLabelCodeListComponent,
		BbListComponent,
		BbLoadingComponent,
		BbFlagComponent,
		BbCanvasComponent,
		BbCanvasElementComponent,
		BbChartComponent,
		BbChipComponent,
		BbMessageComponent,
		BbModalComponent,
		BbPlayerComponent,
		BasicPlayerComponent,
		BbActionsBarComponent,
		BbActiveFiltersComponent,
		BbButtonComponent,
		BbButtonToggleComponent,
		BbAdstatsBlocksComponent,
		BbUploadComponent,
		BbImportComponent,
		BbUploadStatusBoxComponent,
		BbScrollablePaneComponent,
		BbDataSourcePickerComponent,
		BbDropdownButtonComponent,
		BbEditAppComponent,
		BbEditCycleComponent,
		BbContextMenuComponent,
		BbCreatePresetComponent,
		BbHamburgerOverlayComponent,
		BbCronComponent,
		BbDataGridComponent,
		BbPageHeaderComponent,
		BbPasswordInputComponent,
		BbFacetFilterComponent,
		BbFiltersControlsComponent,
		BbFilterSetComponent,
		BbSolrQueryDocumentationComponent,
		BbHorizontalFiltersetComponent,
		BbHorizontalFilterComponent,
		BbVerticalFilterComponent,
		BbFacetListComponent,
		BbPresetsFilterListComponent,
		BbPreviewPageComponent,
		ThumbnailSelectorComponent,
		BbWorklistComponent,
		BbFiltersComponent,
		BbMultiselectComponent,
		BbStateHistoryComponent,
		BbPrebidFieldsComponent,
		BbAspectRatioPickerComponent,
		BbAuctionSettingsComponent,
		BbQRCodeComponent,
		BbToastrComponent,
		BbDragSelectorComponent,
		BbResizableScrollbarComponent,
		BbResizeHandlesComponent,
		BbNotificationCenterComponent,
		BbObjectEditorComponent,
		BbUserMenuComponent,
		BbHubspotComponent,
		BbTextComponent,
		BbTileComponent,
		BbAboutComponent,
		BbTechnicalInfoComponent,
		BbAnalyticsMenuComponent,
		BbLibraryMenuComponent,
		BbAdservicesMenuComponent,
		BbPillboxComponent,
		BbColorPanelComponent,
		BbCloningInfoComponent,
		BbCodeEditorComponent,
		BbCollapsibleComponent,
		BbMenuPanelComponent,
		BbColorPickerBoxComponent,
		BbDimensionComponent,
		BbPublicationMenuComponent,
		BbTempBackMobileComponent,
		BbVastCreativeComponent,
		BbEmbargoComponent,
		BbEmbedBarComponent,
		BbEmptyComponent,
		BbEntityDetailsComponent,
		BbEventHandlersComponent,
		BbEntitySelectorComponent,
		BbFieldRendererComponent,
		BbSelect6Component,
		BbTimeComponent,
		BbTimecodeEditorComponent,
		BbTrimComponent,
		BbFrameSelectComponent,
		BbScreenshotComponent,
		BbTableThumbnailComponent,
		IeFormFieldComponent,
		BbTranscodingComponent,
		BbVersionsComponent,
		FlowchartEditorComponent,
		FlowchartStepComponent,
		FlowchartStatsStepComponent,
		FlowchartColumnsComponent,
		UserPreferencesComponent,
		BbMediaclipSelectorComponent,
		BbMediaclipsPublisherComponent,
		BbLogoSelectorComponent,
		BbMacroSuggestionsComponent,
		BbDatePresetsComponent,
		BbChannelComponent,
		BbChapterEditorComponent,
		BbSubtitleLineEditorComponent,
		BbWeekTimeGridComponent,
		BbWysiwygComponent,
		BbPlayerAspectRatioComponent,
		BbReactComponent,
		BbReactQuickEditComponent,
		LoginUserComponent,
		LoginUserSsoComponent,
		LoginForgotPasswordComponent,
		LoginResetPasswordComponent,
		LoginChoosePublicationComponent,
		BbLineTextComponent
	],
	exports: [
		PipesModule,
		InputsModule,
		TranslateModule,
		BbLabelCodeListComponent,
		BbListComponent,
		BbLoadingComponent,
		BbFlagComponent,
		BbCanvasComponent,
		BbCanvasElementComponent,
		BbChartComponent,
		BbChipComponent,
		BbMessageComponent,
		BbModalComponent,
		BbPageHeaderComponent,
		BbPasswordInputComponent,
		BbFacetFilterComponent,
		BbFiltersControlsComponent,
		BbFilterSetComponent,
		BbSolrQueryDocumentationComponent,
		BbPlayerComponent,
		BasicPlayerComponent,
		BbActionsBarComponent,
		BbActiveFiltersComponent,
		BbButtonComponent,
		BbButtonToggleComponent,
		BbAdstatsBlocksComponent,
		BbUploadComponent,
		BbImportComponent,
		BbUploadStatusBoxComponent,
		BbScrollablePaneComponent,
		BbDataSourcePickerComponent,
		BbDropdownButtonComponent,
		BbEditAppComponent,
		BbEditCycleComponent,
		BbContextMenuComponent,
		BbCreatePresetComponent,
		BbHamburgerOverlayComponent,
		BbCronComponent,
		BbDataGridComponent,
		BbMultiselectComponent,
		DirectivesModule,
		BbHorizontalFiltersetComponent,
		BbHorizontalFilterComponent,
		BbVerticalFilterComponent,
		BbFacetListComponent,
		BbPresetsFilterListComponent,
		BbPreviewPageComponent,
		ThumbnailSelectorComponent,
		BbWorklistComponent,
		BbFiltersComponent,
		BbStateHistoryComponent,
		BbPrebidFieldsComponent,
		BbAspectRatioPickerComponent,
		BbAuctionSettingsComponent,
		BbQRCodeComponent,
		BbToastrComponent,
		BbDragSelectorComponent,
		BbResizableScrollbarComponent,
		BbResizeHandlesComponent,
		BbNotificationCenterComponent,
		BbObjectEditorComponent,
		BbUserMenuComponent,
		BbHubspotComponent,
		BbTextComponent,
		BbTileComponent,
		BbAboutComponent,
		BbTechnicalInfoComponent,
		BbAnalyticsMenuComponent,
		BbLibraryMenuComponent,
		BbAdservicesMenuComponent,
		BbPillboxComponent,
		BbColorPanelComponent,
		BbCloningInfoComponent,
		BbCodeEditorComponent,
		BbCollapsibleComponent,
		BbMenuPanelComponent,
		BbColorPickerBoxComponent,
		BbDimensionComponent,
		BbPublicationMenuComponent,
		BbVastCreativeComponent,
		BbEmbargoComponent,
		BbEmbedBarComponent,
		BbEmptyComponent,
		BbEntityDetailsComponent,
		BbEventHandlersComponent,
		BbEntitySelectorComponent,
		BbFieldRendererComponent,
		BbSelect6Component,
		BbTimeComponent,
		BbTimecodeEditorComponent,
		BbTrimComponent,
		BbFrameSelectComponent,
		BbScreenshotComponent,
		BbTableThumbnailComponent,
		IeFormFieldComponent,
		BbTranscodingComponent,
		BbVersionsComponent,
		FlowchartEditorComponent,
		FlowchartStepComponent,
		FlowchartStatsStepComponent,
		FlowchartColumnsComponent,
		UserPreferencesComponent,
		BbMediaclipSelectorComponent,
		BbMediaclipsPublisherComponent,
		BbLogoSelectorComponent,
		BbMacroSuggestionsComponent,
		BbDatePresetsComponent,
		BbChannelComponent,
		BbChapterEditorComponent,
		BbSubtitleLineEditorComponent,
		BbWeekTimeGridComponent,
		BbWysiwygComponent,
		BbPlayerAspectRatioComponent,
		BbReactComponent,
		BbReactQuickEditComponent,
		LoginUserComponent,
		LoginUserSsoComponent,
		LoginForgotPasswordComponent,
		LoginResetPasswordComponent,
		LoginChoosePublicationComponent,
		BbLineTextComponent
	],
	providers: [
		PublicationService,
		SapiService,
		ToasterService,
		LineupService,
		LiveApiService,
		UploadService,
		TimeService,
		AuthenticationService,
		FilterSetService,
		RealtimeService,
		PrebidService,
		ProjectService,
		ProjectKpiService,
		LocationService,
		MediaclipService,
		AssetService,
		AnalyticsService,
		AdServicesService,
		BbMacrosService,
		BbSelectService,
		CustomFieldsService,
		DatePipe,
		WorklistService,
		MenuService,
		DatafeedService,
		EntityStoreService,
		EntityService,
		FeatureDetectionService,
		FlowchartService,
		NavigateAwayGuard,
		ReleaseService
	]
})
export class SharedModule {

}
